export const DOCUMENTS_DATE_FORMAT = 'MM/dd/yyyy';

export const splitDocumentFilename = (documentName?: string) => {
  const fileName = documentName || '';
  const extensionDot = fileName.lastIndexOf('.');

  const extension = extensionDot !== -1 ? fileName.slice(extensionDot) : '';
  const nameWithoutExtension =
    extensionDot !== -1 ? fileName.slice(0, extensionDot) : fileName;

  const getDocumentNameWithExtension = (value: string) =>
    `${value}${extension}`;

  return { nameWithoutExtension, extension, getDocumentNameWithExtension };
};
